import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ConfigService } from '../../services/config.service';

@Injectable({
    providedIn: 'root'
})

export class EmployeeService {

    constructor(
        private http: HttpClient,
        private configService: ConfigService
    ) { }

    getPaymentMethods(memberId) {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/${this.configService.configs.version}/${environment.employeePaymentMethods}`;
        return this.http.post(apiUrl, { "memberId": memberId });
    }

    getEmployeeList(memberId): Observable<any> {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/${this.configService.configs.version}/member-list`;
        return this.http.post(apiUrl, { "memberId": memberId });
    }

    getEmployeeDetails(memberId: string): Observable<any> {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/${this.configService.configs.version}/employee-details`;
        return this.http.post(apiUrl, { "memberId": memberId });
    }

    getMemberPaymentConfigurations(memberId) {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/v1/${environment.employeePaymentsConfiguration}/${memberId}`;
        return this.http.get(apiUrl);
    }

    getInvoicesList(memberId): Observable<any> {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/${this.configService.configs.version}/invoice-list`;
        return this.http.post(apiUrl, { "memberId": memberId });
    }

    getInvoiceDetails(invoiceId): Observable<any> {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/${this.configService.configs.version}/invoice-fetch`;
        return this.http.post(apiUrl, { "invoiceId": invoiceId });
    }

    downloadInvoiceDetails(params): Observable<any> {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/${this.configService.configs.version}/invoice-download`;
        return this.http.post(apiUrl, params);
    }

    getPaymentsList(memberId) {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/${this.configService.configs.version}/payments-list`;
        return this.http.post(apiUrl, { memberId: memberId });
    }

    updatePaymentMethods(params) {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/${this.configService.configs.version}/payment-methods-update`;
        return this.http.post(apiUrl, params);
    }

    updateCheckboxValue(params) {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/${this.configService.configs.version}/payment-default-save`;
        return this.http.post(apiUrl, params)
    }

    updatePaymentStatus(params) {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/${this.configService.configs.version}/payment-methods-status`;
        return this.http.post(apiUrl, params)
    }

    updateSecondaryPaymentMethodStatus(params) {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/v2/employee/update-secondary-payment`;
        return this.http.post(apiUrl, params)
    }

    getPaymentInvoice(invoiceId) {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/${this.configService.configs.version}/invoice-fetch`;
        return this.http.post(apiUrl, { "invoiceId": invoiceId });
    }

    savePaymentMethods(body) {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/${this.configService.configs.version}/payment-methods-save`;
        return this.http.post(apiUrl, body);
    }

    getPolicyList(memberId) {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/v2/${environment.employeePolicyList}`;
        return this.http.post(apiUrl, { memberId: memberId });
    }

    getStateCodes() {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/v2/state-codes`;
        return this.http.get(apiUrl);
    }

    quickEnrollEmployeeSave(body) {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/v2/${environment.quickEnrollEmployeeSave}`;
        return this.http.post(apiUrl, body);
    }

    quickEnrollEmployeeDetails(employeeId) {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/v2/${environment.quickEnrollEmployeeDetails}/${employeeId}`;
        return this.http.get(apiUrl);
    }

    quickEnrollEmployeeDetailsByFields(body) {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/v2/${environment.quickEnrollEmployeeDetailsByFields}`;
        return this.http.post(apiUrl, body);
    }

    quickEnrollGetCoverage(employeeId) {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/v2/${environment.quickEnrollGetCoverage}/${employeeId}`;
        return this.http.get(apiUrl);
    }

    quickEnrollGetPlans(body) {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/v2/${environment.quickEnrollGetPlans}`;
        return this.http.post(apiUrl, body);
    }

    quickEnrollGetPaymentMethods(body): Observable<any> {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/v2/${environment.quickEnrollGetPaymentMethods}`;
        return this.http.post(apiUrl, body);
    }

    quickEnrollDependentDelete(dependentId) {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/v2/${environment.quickEnrollDependentDelete}/${dependentId}`;
        return this.http.delete(apiUrl);
    }

    quickEnrollUpdateWaiveCoverage(body) {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/v2/${environment.quickEnrollUpdateWaiveCoverage}`;
        return this.http.post(apiUrl, body);
    }

    quickEnrollDocumentSave(body) {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/v2/${environment.quickEnrollDocumentSave}`;
        return this.http.post(apiUrl, body);
    }

    quickEnrollDocumentList(employeeId) {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/v2/${environment.quickEnrollDocumentList}/${employeeId}`;
        return this.http.get(apiUrl);
    }

    quickEnrollGetOrganizationDetails(host) {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/v2/${environment.quickEnrollOrganizationDetails}`;
        return this.http.post(apiUrl, { host: host });
    }
    getEmployeePaymentDetails(invoiceId) {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/v2/${environment.employeeDefaultPaymentDetails}/${invoiceId}`;
        return this.http.get(apiUrl);
    }

    employeeInvoicePayment(body) {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/v2/${environment.employeeInvoicePayment}`;
        return this.http.post(apiUrl, body);
    }

    invoiceDetailsDownload(params): Observable<any> {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/${this.configService.configs.version}/invoice-details-download`;
        return this.http.post(apiUrl, params);
    }

    quickEnrollUpdateDefaultPaymentMethod(params) {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/v2/quick-enroll/payment-default-save`;
        return this.http.post(apiUrl, params)
    }
    sendCardByMail(params) {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/v2/employee/${environment.sendCardByMail}`;
        return this.http.post(apiUrl, params);
    }

    downloadIdCard(policyid) {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/v2/employee/${environment.downloadIdCard}/${policyid}`;
        return this.http.get(apiUrl, { responseType: 'blob' });
    }

    inviteToPortal(params) {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/v2/${environment.inviteToPortal}`;
        return this.http.post(apiUrl, params);
    }

    shareClaimsData(params) {
        const apiUrl = `${this.configService.configs.apiBaseUrl}/v2/${environment.shareClaimsData}`;
        return this.http.post(apiUrl, params);
    }
}
